import React from 'react'
import WebhookPixAutomaticoListPageContainer from './WebhookPixAutomaticoListPageContainer'

export class WebhookPixAutomaticoListPage extends React.Component {
  render() {
    return <WebhookPixAutomaticoListPageContainer {...this.props} />
  }
}
